module.exports = __webpack_public_path__ + "public/img/ico-tabbar-inactive-profile.049e320d.svg";